import { render, staticRenderFns } from "./agogis-module-lookup.vue?vue&type=template&id=0fda6d27"
import script from "./agogis-module-lookup.vue?vue&type=script&lang=ts"
export * from "./agogis-module-lookup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports